// oxlint-disable react-perf/jsx-no-new-object-as-prop
import { Box, useOpenClose } from '@palmetto/palmetto-components';

import { AllDocumentTypes, documentTitles, QueueRejectionReason, UtilityBillRejectionReasons } from 'types';

import { CollapsibleDetails } from './CollapsibleDetails';
import EventBy from './EventBy';

const getRejectionLabel = (reason: string): string =>
  (QueueRejectionReason as Record<string, string>)[reason] ||
  (UtilityBillRejectionReasons as Record<string, string>)[reason] ||
  reason;

const DataRow = ({ label, value }: { label: string; value: string }) => (
  <Box direction="row" childGap="sm">
    <Box as="span" fontWeight="bold" style={{ minWidth: '140px' }}>
      {label}:
    </Box>
    <Box as="span">{value}</Box>
  </Box>
);

const SabalDocumentRejected = ({ event }: { event: any }) => {
  const { isOpen, handleToggle } = useOpenClose();

  const files = event.data?.document?.files?.map((file: any) => file.originalName).join(', ');
  const typeOfDocument: AllDocumentTypes = event.data?.document?.type;
  const rejectionDetails = event.data?.rejectionDetails;
  const rejectionReasons: string[] = rejectionDetails?.rejectionReasons ?? [];
  const rejectionNote: string | undefined = rejectionDetails?.rejectionNote;

  return (
    <Box display="block" childGap="sm">
      <Box display="block">
        <Box as="span" display="inline-block" margin="0 2xs 0 0">
          <EventBy event={event} /> rejected <strong>{documentTitles[typeOfDocument]}</strong> document
          {event.data?.document?.files?.length > 1 && 's'} <strong>{files}</strong>
        </Box>
      </Box>

      {rejectionDetails && (
        <CollapsibleDetails title="Rejection Details" isOpen={isOpen} onToggle={handleToggle}>
          {rejectionReasons.length > 0 && (
            <DataRow label="Rejection Reasons" value={rejectionReasons.map(getRejectionLabel).join(', ')} />
          )}

          {rejectionNote && <DataRow label="Notes" value={rejectionNote} />}
        </CollapsibleDetails>
      )}
    </Box>
  );
};

export default SabalDocumentRejected;
